module.exports = __webpack_public_path__ + "static/media/4.8107de13.png";